import React from 'react';
import CustomInput from '../../CustomInput';

export default function GeneralDataInputs({ onChange, data, errors }) {
    return (
        <>
            <p className="form__input-group-header">GENERAL</p>
            <div className="form__item-wrapper">
                <CustomInput
                    id="name"
                    placeholder="Enter client name"
                    onInputChange={onChange}
                    inputValue={data.name}
                    labelText="Name"
                    width="100%"
                    errorText={errors?.name}
                />
            </div>
            <div className="form__item-wrapper">
                <CustomInput
                    id="client_uid"
                    placeholder="Enter client ID"
                    onInputChange={onChange}
                    inputValue={data.client_uid}
                    labelText="ClientID"
                    width="100%"
                    errorText={errors?.client_uid}
                />
            </div>
            <div className="form__item-wrapper">
                <CustomInput
                    id="api_url"
                    placeholder="Enter API URL"
                    onInputChange={onChange}
                    inputValue={data.api_url}
                    labelText="API URL"
                    width="100%"
                    errorText={errors?.api_url}
                />
            </div>
            <div className="form__item-wrapper">
                <CustomInput
                    id="crm_url"
                    placeholder="Enter CRM URL"
                    onInputChange={onChange}
                    inputValue={data.crm_url}
                    labelText="CRM URL"
                    width="100%"
                    errorText={errors?.crm_url}
                />
            </div>
        </>
    );
}
